/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const SteeringWheel = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5ZM7.5 12.5C9.36856 12.5 10.8951 13.9643 10.9948 15.808L11 16L11 19.9381C7.21631 19.4663 4.25315 16.3522 4.0154 12.5005L7.5 12.5ZM19.9846 12.5005C19.7468 16.3522 16.7837 19.4663 13 19.9381L13 16C13 14.1314 14.4643 12.6049 16.308 12.5052L16.5 12.5L19.9846 12.5005ZM7.5 14L5.81364 14.0004C6.39891 15.8117 7.7576 17.2754 9.50043 18.002L9.5 16C9.5 14.8954 8.60457 14 7.5 14ZM18.1864 14.0004L16.5 14C15.3954 14 14.5 14.8954 14.5 16L14.5006 18.0016C16.2429 17.2748 17.6012 15.8114 18.1864 14.0004ZM12 11.5C12.5523 11.5 13 11.9477 13 12.5C13 13.0523 12.5523 13.5 12 13.5C11.4477 13.5 11 13.0523 11 12.5C11 11.9477 11.4477 11.5 12 11.5ZM12 4C15.9057 4 19.1577 6.79892 19.8597 10.5004H4.14032C4.84226 6.79892 8.09427 4 12 4ZM12 5.5C9.49231 5.5 7.31629 6.92007 6.23225 8.99992H17.7677C16.6837 6.92007 14.5077 5.5 12 5.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
